module.exports = __webpack_public_path__ + "static/img/2009.69ebabc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2009.jpg
// module id = 300
// module chunks = 0